// export const BASE_URL = "http://13.202.145.118:4000/api/v1";
// export const Image_BASE_URL = "http://13.202.145.118:4000/";
// export const FILE_BASE_URL = "http://13.202.145.118:4000/";

// export const BASE_URL = "http://localhost:4001/api/v1";
// export const Image_BASE_URL = "http://localhost:4001";
// export const FILE_BASE_URL = "http://localhost:4001";

//export const BASE_URL = "https://champapi.wetap.in/api/v1";
//export const Image_BASE_URL = "https://champapi.wetap.in/";
//export const FILE_BASE_URL = "https://champapi.wetap.in/";
//
export const BASE_URL = 'https://api.champenduranceadmin.com/api/v1';
export const Image_BASE_URL = 'https://api.champenduranceadmin.com/';
export const FILE_BASE_URL = 'https://api.champenduranceadmin.com/';

